module.exports = new __parcel__URL__("Mageskill_12.87135fd3.png").toString();